module.exports = __webpack_public_path__ + "img/invoice_request_id.4c90113e.svg";